import { combineReducers } from "redux";

import auth from "./auth";
import system from "./system";
import entities from "./entities";
import entity from "modules/entity/reducers";

const rootReducer = combineReducers({
  auth,
  system,
  entities,
  entity,
});

export default (state, action) =>
  action.type === "LOGOUT/REQUEST"
    ? rootReducer({ system: state.system }, action)
    : rootReducer(state, action);
